import { Checkbox, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { Delete, Edit, ExpandMore, ExpandLess } from "@mui/icons-material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { openDialog } from "../../features/dialog";

function GroupTable({groups, selection, setSelection}){
    const dispatch = useDispatch();
    const [expandedGroups, setExpandedGroups] = useState({});

    const toggleSelect = id => {
        let _selection = [];
        if(selection.indexOf(id)!==-1){
            _selection = selection.filter(s => s !== id);
        }else{
            _selection = [
                ...selection,
                id
            ]
        }
        setSelection(_selection);
    }

    const toggleExpand = (groupId) => {
        setExpandedGroups(prev => ({
            ...prev,
            [groupId]: !prev[groupId]
        }));
    }

    return <>
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell width={40}>
                        <Checkbox 
                            checked={selection.length > 0}
                            indeterminate={selection.length > 0 && selection.length !== groups.length} 
                            onChange={(e) => {
                                if(e.target.checked){
                                    setSelection(groups.map(r => r.groupId));
                                }else{
                                    setSelection([])
                                }
                            }}
                        />
                    </TableCell>
                    <TableCell width={40}></TableCell>
                    <TableCell>ID</TableCell>
                    <TableCell>Group Name</TableCell>
                    <TableCell>Channels</TableCell>
                    <TableCell></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {groups.map((group,i) => {
                    const selected = selection.indexOf(group.groupId) !== -1;
                    const isExpanded = expandedGroups[group.groupId];
                    const channelCount = group.channels ? group.channels.length : 0;
                    
                    return [
                        <TableRow key={`group-${i}`} hover>
                            <TableCell>
                                <Checkbox checked={!!selected} onChange={() => toggleSelect(group.groupId)} />
                            </TableCell>
                            <TableCell>
                                {channelCount > 0 && (
                                    <IconButton size="small" onClick={() => toggleExpand(group.groupId)}>
                                        {isExpanded ? <ExpandLess /> : <ExpandMore />}
                                    </IconButton>
                                )}
                            </TableCell>
                            <TableCell width={140}>{group.groupId}</TableCell>
                            <TableCell style={{
                                whiteSpace: "normal",
                                wordWrap: "break-word"
                            }}>
                                {group.groupLabel}
                            </TableCell>
                            <TableCell width={150}>
                                {channelCount} channel{channelCount !== 1 ? 's' : ''}
                            </TableCell>
                            <TableCell align="right" width={130}>
                                <Tooltip title="Edit">
                                    <IconButton size="small" onClick={() => {
                                        dispatch(openDialog({id: "editGroup", props: group}));
                                    }}><Edit /></IconButton>
                                </Tooltip>
                                <Tooltip title="Delete">
                                    <IconButton size="small" onClick={() => {
                                        dispatch(openDialog({id: "deleteGroup", props: group.groupId}));
                                    }}><Delete /></IconButton>
                                </Tooltip>
                            </TableCell>
                        </TableRow>,
                        // Expanded channels rows
                        ...(isExpanded && group.channels ? group.channels.map((channel, channelIndex) => (
                            <TableRow key={`channel-${i}-${channelIndex}`} style={{backgroundColor: '#f5f5f5'}}>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell width={140}>{channel.id}</TableCell>
                                <TableCell style={{
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                    paddingLeft: 32
                                }}>
                                    {channel.channelName} ({channel.platform})
                                </TableCell>
                                <TableCell>{channel.channelId}</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        )) : [])
                    ];
                }).flat()}
            </TableBody>
        </Table>
    </>
}

export default GroupTable;